import { createFileRoute, notFound } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { hasPrivilegeToViewUserGroups, UserGroupsView } from '@mews-commander/modules/src/modules/userGroups';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/UserGroups/Index/')({
    beforeLoad: ({ context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState } }) => {
        const state = getState();
        if (!hasPrivilegeToViewUserGroups(state)) {
            throw notFound();
        }
    },
    component: UserGroupsView,
    staticData: {
        routeName: RouteName.UserGroupsListIndex,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
        title: TextKey.UserGroups,
        guideLink: createGuideLink(ArticlePath.UserGroupsListIndex),
    },
});
